import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import React from "react";
import FormRow from "../../components/formrow";
import { type GetSetValueProp } from "../models";
import { ArtistMultiModalPicker } from "components/Picker/ArtistPicker/ArtistMultiModalPicker";
import { ProductionMultiModalPicker } from "components/Picker/ProductionPicker/ProductionMultiModalPicker";

export type FilterByTypes = "AllArtists" | "MultipleArtists" | "Productions";

interface IChooseArtistProps {
  filterType: GetSetValueProp<FilterByTypes>
  onFilterIdsChanged: (newIds: number[]) => void
}

const FilterBy = (props: IChooseArtistProps) => {
  // Keep an internal state as we need to maintain meta-info about artist selections
  // Onchange we only pass new artist ids, but we need to maintain a list of artist names etc
  const [selectedArtists, setSelectedArtists] = React.useState<server.dto.ArtistSmall[]>([]);
  const [selectedProductions, setSelectedProductions] = React.useState<server.dto.ProductionSmallV2[]>([]);

  const onArtistSelectionUpdated = (artists: server.dto.ArtistSmall[]) => {
    const ids = artists.map((a) => a.artistId);
    props.onFilterIdsChanged(ids);
    setSelectedArtists(artists);
  };

  const onProductionsSelectionUpdated = (productions: server.dto.ProductionSmallV2[]) => {
    const ids = productions.map((p) => p.productionId);
    props.onFilterIdsChanged(ids);
    setSelectedProductions(productions);
  };

  const permanentOptions = [{
    label: RESX.GeneralLabels.All,
    value: "AllArtists"
  }, {
    label: RESX.NotificationSettings.OnlyASelectionOfArtists,
    value: "MultipleArtists"
  }];
  const productionOption = {
    label: RESX.Production.SelectionOfProductions,
    value: "Productions"
  };
  const options = site.currentEnvironment.production.enabled ? [...permanentOptions, productionOption] : permanentOptions;

  return <FormRow label={RESX.EmbedWizard.Display}>
    <div className="flex-column gap">
      <RadioGroup
        orientation="vertical"
        options={options}
        value={props.filterType.value}
        onChange={(value) => props.filterType.setValue(value as FilterByTypes)}
      />

      {props.filterType.value === "MultipleArtists" && <div>
        <ArtistMultiModalPicker
          securityScope="allForClient"
          value={selectedArtists}
          onChange={onArtistSelectionUpdated}
          required={false}
          canCreateNew={false}
          validatorKey="artistPicker"
        />
      </div>}

      {props.filterType.value === "Productions" && <div>
        <ProductionMultiModalPicker
          value={selectedProductions}
          onChange={onProductionsSelectionUpdated}
          required={false}
          canCreateNew={false}
          validatorKey="productionsPicker"
        />
      </div>}
    </div>
  </FormRow>;
};

export default FilterBy;